export  function scrollCarousel(direction, ref) {
    if (!ref.current) return;
    const scrollAmount = 220;
    ref.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  }